import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSupplierUsagePlanDetail } from "actions/supplierAction";
import SupplierUsagePlan from "models/SupplierUsagePlan";

// const useGetUsagePlanDetail = (id, query , isTrigger = true) => {
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [usagePlan, setUsagePlan] = useState(new SupplierUsagePlan());
//   useEffect(() => {
//     const fetch = () => {
//       setLoading(true);
//       dispatch(getSupplierUsagePlanDetail(id, query, {
//         callbacks: {
//           onSuccess: (result) => {
//             setUsagePlan(result);
//             setLoading(false);
//           },
//           onFailed: () => {}
//         }
//       }));
//     };

//     if (id) {
//       fetch();
//     }
//   }, [id, isTrigger,query, dispatch]);

//   return {
//     usagePlan,
//     loading,
//     setUsagePlan,
//   }
// };

const useGetUsagePlanDetail = (id, isTrigger = true) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [usagePlan, setUsagePlan] = useState(new SupplierUsagePlan());
  useEffect(() => {
    const fetch = () => {
      setLoading(true);
      dispatch(getSupplierUsagePlanDetail(id, {
        callbacks: {
          onSuccess: (result) => {
            setUsagePlan(result);
            setLoading(false);
          },
          onFailed: () => {}
        }
      }));
    };

    if (id) {
      fetch();
    }
  }, [id, isTrigger, dispatch]);

  return {
    usagePlan,
    loading,
    setUsagePlan,
  }
};

export default useGetUsagePlanDetail;
